import { render, staticRenderFns } from "./AccessWithTokenLoader.vue?vue&type=template&id=82a5cf70&scoped=true"
import script from "./AccessWithTokenLoader.vue?vue&type=script&lang=js"
export * from "./AccessWithTokenLoader.vue?vue&type=script&lang=js"
import style0 from "./AccessWithTokenLoader.vue?vue&type=style&index=0&id=82a5cf70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a5cf70",
  null
  
)

export default component.exports